import { ApplicationData } from '__generated__/api';
import { http } from '../http';

export async function getConceptsData(
  commercialRelation: string | null
): Promise<ApplicationData[]> {
  const response = await http.get(
    `/api/applicationdata/concepts/commercialrelation/${commercialRelation}`
  );
  return response.data;
}
